import React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

const action = { minWidth: 44, minHeight: 44,
  '&:focus-visible': { outline: '3px solid #352179', outlineOffset: 2 } };

export default function CeteleDeleteDialog({ target, busy, error, onClose, onConfirm, onExited, teacher = false }) {
  const whole = target?.kind === 'cetele';
  return <Dialog open={Boolean(target)} onClose={() => !busy && onClose()} fullWidth maxWidth="xs"
    TransitionProps={{ onExited }}
    aria-labelledby="cetele-delete-title" aria-describedby="cetele-delete-description"
    PaperProps={{ className: teacher ? 'teacher-ceteles tc-dialog' : undefined,
      sx: { m: 1.5, width: 'calc(100% - 24px)', maxHeight: 'calc(100dvh - 24px)' } }}>
    <DialogTitle id="cetele-delete-title">{whole ? 'Çeteleyi silmek istiyor musun?' : 'Değerlendirmeyi silmek istiyor musun?'}</DialogTitle>
    <DialogContent>
      <DialogContentText id="cetele-delete-description" sx={{ color: '#34334a', overflowWrap: 'anywhere' }}>
        <strong>{target?.title}</strong>{whole
          ? ' çetelesi, tüm değerlendirmeleri ve öğrenci sonuçları silinecek.'
          : ' değerlendirmesi ve bu değerlendirmeye ait tüm öğrenci sonuçları silinecek.'}
        {' '}Bu işlem geri alınamaz. Kazanılmış DANDU puanları korunur.
      </DialogContentText>
      {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
      <Button autoFocus disableRipple sx={{ ...action, color: '#55339b',
        '&:hover': { bgcolor: '#f3edff' } }} disabled={busy} onClick={onClose}>Vazgeç</Button>
      <Button className="tc-delete-confirm" variant="contained" color="error" sx={{ ...action, bgcolor: '#b91c1c', color: '#fff',
        '&:hover': { bgcolor: '#991b1b' },
        '&:focus-visible': { outline: '3px solid #352179', outlineOffset: 2 } }}
        disabled={busy} onClick={onConfirm}>{busy ? 'Siliniyor…' : 'Evet, Sil'}</Button>
    </DialogActions>
  </Dialog>;
}
